import { z } from 'zod';
// Schema definitions for tool inputs
export const TakeScreenshotSchema = z.object({
    outputPath: z
        .string()
        .optional()
        .describe('Path to save the screenshot (optional, defaults to temp directory)'),
    windowTitle: z.string().optional().describe('Specific window title to screenshot (optional)'),
    targetId: z
        .string()
        .optional()
        .describe('CDP target ID (from electron_list_windows). Takes precedence over windowTitle when both are provided. Required for unambiguous targeting when multiple Electron apps run on different debugging ports.'),
});
export const ReadElectronLogsSchema = z.object({
    logType: z
        .enum(['console', 'main', 'renderer', 'all'])
        .optional()
        .describe('Type of logs to read'),
    lines: z.number().optional().describe('Number of recent lines to read (default: 100)'),
    follow: z.boolean().optional().describe('Whether to follow/tail the logs'),
});
export const GetElectronWindowInfoSchema = z.object({
    includeChildren: z.boolean().optional().describe('Include child windows information'),
});
export const ListElectronWindowsSchema = z.object({
    includeDevTools: z
        .boolean()
        .optional()
        .describe('Include DevTools windows in the list (default: false)'),
});
